import _toConsumableArray from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { hasDiscreteDomain } from '../../scale';
import { getFirstDefined } from '../../util';
import { isVgRangeStep } from '../../vega.schema';
import { isFacetModel } from '../model';
export function assembleLayoutSignals(model) {
  return [].concat(_toConsumableArray(sizeSignals(model, 'width')), _toConsumableArray(sizeSignals(model, 'height')));
}
export function sizeSignals(model, sizeType) {
  var channel = sizeType === 'width' ? 'x' : 'y';
  var size = model.component.layoutSize.get(sizeType);

  if (!size || size === 'merged') {
    return [];
  } // Read size signal name from name map, just in case it is the top-level size signal that got renamed.


  var name = model.getSizeSignalRef(sizeType).signal;

  if (size === 'range-step') {
    var scaleComponent = model.getScaleComponent(channel);

    if (scaleComponent) {
      var type = scaleComponent.get('type');
      var range = scaleComponent.get('range');

      if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
        var scaleName = model.scaleName(channel);

        if (isFacetModel(model.parent)) {
          // If parent is facet and this is an independent scale, return only signal signal
          // as the width/height will be calculated using the cardinality from
          // facet's aggregate rather than reading from scale domain
          var parentResolve = model.parent.component.resolve;

          if (parentResolve.scale[channel] === 'independent') {
            return [stepSignal(scaleName, range)];
          }
        }

        return [stepSignal(scaleName, range), {
          name: name,
          update: sizeExpr(scaleName, scaleComponent, "domain('".concat(scaleName, "').length"))
        }];
      }
    }
    /* istanbul ignore next: Condition should not happen -- only for warning in development. */


    throw new Error('layout size is range step although there is no rangeStep.');
  } else {
    return [{
      name: name,
      value: size
    }];
  }
}

function stepSignal(scaleName, range) {
  return {
    name: scaleName + '_step',
    value: range.step
  };
}

export function sizeExpr(scaleName, scaleComponent, cardinality) {
  var type = scaleComponent.get('type');
  var padding = scaleComponent.get('padding');
  var paddingOuter = getFirstDefined(scaleComponent.get('paddingOuter'), padding);
  var paddingInner = scaleComponent.get('paddingInner');
  paddingInner = type === 'band' ? // only band has real paddingInner
  paddingInner !== undefined ? paddingInner : padding : // For point, as calculated in https://github.com/vega/vega-scale/blob/master/src/band.js#L128,
  // it's equivalent to have paddingInner = 1 since there is only n-1 steps between n points.
  1;
  return "bandspace(".concat(cardinality, ", ").concat(paddingInner, ", ").concat(paddingOuter, ") * ").concat(scaleName, "_step");
}